import React, { useCallback, useEffect, useRef, useState } from 'react';
import './index.scss';
import { NOTIFIES, PINNED_CAMERAS, DECODED_ACCESS_TOKEN } from '../../constants/system.keys';
import * as SERVICE from '../../constants/service.types';
import { ExclamationCircleOutlined, InfoCircleOutlined, LogoutOutlined, ReloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  Switch,
  Table,
  Tabs,
  Tooltip,
  Typography,
} from 'antd';
import { authLogoutThunk, changeLocales, openMessage, socketEmitEvent, updateNamespace, } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import point from './point.png';
import EmailTag from './EmailTag';
import All_Services from '../../assets/icons/All_Services.svg';
import { resetDataToken } from '../../redux/socket';
import ChangePassword from './ChangePassword';
import storageService from '../../services/storage.service';

const { Option } = Select;
const { confirm } = Modal;
const { TabPane } = Tabs;
const { Paragraph } = Typography;

const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 18,
  },
};
const validateMessages = {
  required: 'This field is required!',
  types: {
    email: 'Not a validate email!',
    number: 'Not a validate number!',
  },
  number: {
    // eslint-disable-next-line no-template-curly-in-string
    range: 'Must be between ${min} and ${max}',
  },
};
const ProfilePage = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [textInput] = Form.useForm();
  const dispatch = useDispatch();
  const [resetting, setResetting] = useState(false);
  const [resettingApi, setResettingApi] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const refCopy = useRef(null);
  const {
    isAuth,
    dataUser,
    language: localLanguage,
    namespace,
    namespaces: listNamespace,
    resetToken,
    reNewApiToken,
    listLicense,
    userId,
  } = useSelector((state) => state);

  const [openModalChangePassword, setOpenModalChangePassword] = useState(false);
  const [language, setLanguage] = useState();
  const [modeCamera, setModeCamera] = useState('auto');
  const [pinCamera, setpinCamera] = useState(false);
  const [token, setToken] = useState();
  const [apiToken, setApiToken] = useState();
  const [namespaces, setNamespaces] = useState();
  const [fileList, setFileList] = useState([]);
  const [requestId, setRequestId] = useState(new Date().getTime());
  const [email, setEmail] = useState(null);
  const [change1, setChange1] = useState(false);
  const [change2, setChange2] = useState(false);
  const [change3, setChange3] = useState(false);
  const [change4, setChange4] = useState(false);
  const [change5, setChange5] = useState(false);
  const [change6, setChange6] = useState(true);

  useEffect(() => {
    const modeCameraStorage = localStorage.getItem('mode_camera');
    const pinCameraStorage = localStorage.getItem('pin_camera');
    if (modeCameraStorage) {
      setModeCamera(modeCameraStorage);
    }
    if (pinCameraStorage) {
      setpinCamera(JSON.parse(pinCameraStorage));
    }
  }, []);

  useEffect(() => {
    if (listNamespace) {
      setNamespaces(listNamespace);
    }
    return () => {
      setNamespaces(null);
    };
  }, [listNamespace]);

  useEffect(() => {
    let ref;
    if (isCopied) {
      ref = setTimeout(() => {
        setIsCopied(false);
      }, 5000);
    }
    return () => {
      clearInterval(ref);
    };
  }, [isCopied]);

  useEffect(() => {
    if (resetToken && resetToken.requestId === requestId) {
      setToken(resetToken.token);
      setResetting(false);
      openMessage(NOTIFIES.SUCCESS, t('Reset token successfully'));
    }
  }, [requestId, resetToken, t]);

  useEffect(() => {
    if (reNewApiToken && reNewApiToken.requestId === requestId) {
      setApiToken(reNewApiToken.apiToken);
      setResettingApi(false);
      openMessage(NOTIFIES.SUCCESS, t('Renew token successfully'));
    }
  }, [reNewApiToken, requestId, t]);

  useEffect(() => {
    if (localLanguage) {
      setLanguage(localLanguage);
    }
  }, [language, localLanguage]);

  const handleUpdateLanguage = useCallback(
    (lang) => {
      setLanguage(lang);
      dispatch(changeLocales(lang));
    },
    [dispatch]
  );
  const handleChangeNamespace = (value) => {
    return dispatch(updateNamespace(value));
  };
  const copyCodeToClipboard = () => {
    const el = refCopy.current;
    el.select();
    document.execCommand('copy');
    setIsCopied(true);
  };

  const handleResetToken = useCallback(() => {
    confirm({
      title: t('Do you want to reset the token?'),
      icon: <ExclamationCircleOutlined />,
      okText: t('Reset'),
      onOk() {
        setResetting(true);
        let data = {
          namespace,
        };
        const dataTimeRequest = new Date().getTime();
        setRequestId(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.RESET_TOKEN,
          requestId: dataTimeRequest,
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      },
      onCancel() {},
    });
  }, [dispatch, namespace, t]);

  const handleResetApiToken = useCallback(() => {
    confirm({
      title: t('Do you want to renew the token?'),
      icon: <ExclamationCircleOutlined />,
      okText: t('Renew'),
      onOk() {
        setResettingApi(true);
        let data = {
          namespace,
        };
        const dataTimeRequest = new Date().getTime();
        setRequestId(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.GENERATE_API_ACCESS_TOKEN,
          requestId: dataTimeRequest,
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      },
      onCancel() {},
    });
  }, [dispatch, namespace, t]);

  useEffect(() => {
    if (isAuth === 1) {
      let data = {};
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest);
      let dataObj = {
        appServiceType: SERVICE.LIST_NAMESPACE_BY_ACCOUNT,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
    return () => {};
  }, [dispatch, isAuth]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      let data = {
        namespace,
      };
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest);
      let dataObj = {
        appServiceType: SERVICE.LIST_LICENSE_BY_NAMESPACE,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
    return () => {};
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    if (isAuth === 1 && !token) {
      let localToken = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
      if (localToken) {
        setToken(localToken);
      }
    }
  }, [isAuth, token]);

  useEffect(() => {
    if (dataUser) {
      setApiToken(dataUser?.apiAccessToken);
    }
  }, [dataUser]);

  useEffect(() => {
    if (dataUser) {
      form.resetFields();
      form.setFieldsValue({
        ...dataUser,
        birthday: dataUser.birthday
          ? moment(dataUser.birthday, 'YYYY-MM-DD')
          : undefined,
        balance: `${dataUser && dataUser.balance} VND`,
        idSocial: `${dataUser.idSocial.slice(
          0,
          dataUser.idSocial && dataUser.idSocial.length - 2
        )}**`,
        email: dataUser && dataUser.email && dataUser.email.split(';'),
      });
    }
  }, [dataUser, form]);

  const onFinish = (values) => {
    showConfirm(() => {
      const { fullName, birthday, idSocial, address } = values;
      let errors = [];
      fullName &&
        fullName.trim().length === 0 &&
        errors.push({
          name: 'fullName',
          errors: [t('The input field is not valid!')],
        });
      idSocial &&
        idSocial.trim().length === 0 &&
        errors.push({
          name: 'idSocial',
          errors: [t('The input field is not valid!')],
        });
      address &&
        address.trim().length === 0 &&
        errors.push({
          name: 'address',
          errors: [t('The input field is not valid!')],
        });

      if (errors.length > 0) {
        return form.setFields(errors);
      } else {
        const dataBody = {
          fullName: fullName.trim(),
          birthday: moment(birthday).valueOf() + 86400000,
          idSocial: idSocial.trim(),
          address: address.trim(),
          namespace,
        };
        const dataTimeRequest = new Date().getTime();
        setRequestId(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.UPDATE_USER_INFO,
          requestId: dataTimeRequest,
          body: JSON.stringify(dataBody),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    });
  };

  const onFinish1 = (key) => {
    form.validateFields().then((values) => {
      let dataBody = {};
      if (key === 'idSocial') {
        dataBody = {
          fullName: values.fullName && values.fullName.trim(),
          idSocial: values.idSocial && values.idSocial.trim(),
          email: email === null ? dataUser.email : email,
          address: values.address && values.address.trim(),
          birthday: moment(values.birthday).valueOf() + 86400000,
          namespace,
        };
      } else {
        dataBody = {
          fullName: values.fullName && values.fullName.trim(),
          idSocial: dataUser.idSocial,
          email: email === null ? dataUser.email : email,
          address: values.address && values.address.trim(),
          birthday: moment(values.birthday).valueOf() + 86400000,
          namespace,
        };
      }
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest);
      let dataObj = {
        appServiceType: SERVICE.UPDATE_USER_INFO,
        requestId: dataTimeRequest,
        body: JSON.stringify(dataBody),
      };
      setChange1(false);
      setChange2(false);
      setChange3(false);
      setChange4(false);
      setChange5(false);
      return dispatch(socketEmitEvent(dataObj));
    });
  };

  const onCancel1 = () => {
    form.resetFields();
    form.setFieldsValue({
      ...dataUser,
      birthday: dataUser.birthday
        ? moment(dataUser.birthday, 'YYYY-MM-DD')
        : undefined,
      balance: `${dataUser && dataUser.balance} VND`,
      idSocial: `${dataUser.idSocial.slice(
        0,
        dataUser.idSocial && dataUser.idSocial.length - 2
      )}**`,
      email: dataUser && dataUser.email && dataUser.email.split(';'),
    });
    setEmail(dataUser && dataUser.email);
    setChange1(false);
    setChange2(false);
    setChange3(false);
    setChange4(false);
    setChange5(false);
  };

  const onChange1 = (check) => {
    form.resetFields();
    form.setFieldsValue({
      ...dataUser,
      birthday: dataUser.birthday
        ? moment(dataUser.birthday, 'YYYY-MM-DD')
        : undefined,
      balance: `${dataUser && dataUser.balance} VND`,
      idSocial:
        check === '2'
          ? dataUser.idSocial
          : `${dataUser.idSocial.slice(
              0,
              dataUser.idSocial && dataUser.idSocial.length - 2
            )}**`,
      email: dataUser && dataUser.email && dataUser.email.split(';'),
    });
    setEmail(dataUser && dataUser.email);
    if (check === '1') {
      setChange2(false);
      setChange3(false);
      setChange4(false);
      setChange5(false);
      setChange1(true);
    } else if (check === '2') {
      setChange1(false);
      setChange3(false);
      setChange4(false);
      setChange5(false);
      setChange2(true);
    } else if (check === '3') {
      setChange1(false);
      setChange2(false);
      setChange4(false);
      setChange5(false);
      setChange3(true);
    } else if (check === '4') {
      setChange1(false);
      setChange2(false);
      setChange3(false);
      setChange5(false);
      setChange4(true);
    } else if (check === '5') {
      setChange1(false);
      setChange2(false);
      setChange3(false);
      setChange4(false);
      setChange5(true);
    }
  };

  const showConfirm = (callback) => {
    confirm({
      title: t('Do you want to update your profile?'),
      icon: <ExclamationCircleOutlined />,
      okText: t('Update'),
      onOk() {
        return callback();
      },
      onCancel() {},
    });
  };
  const handleOnLogout = () => {
    return confirm({
      title: t('Do you want to log out?'),
      icon: <LogoutOutlined />,
      okText: t('Logout'),
      onOk() {
        resetDataToken();
        dispatch(authLogoutThunk());
        let hashKey = `${PINNED_CAMERAS}.${namespace}.${userId}`;
        localStorage.removeItem(hashKey);
      },
      onCancel() {},
    });
  };
  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const onChangeEmail = (dataArr) => {
    setEmail(dataArr && dataArr.join(';'));
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const handleSelectMode = (value) => {
    setModeCamera(value);
    localStorage.setItem('mode_camera', value);
  };

  const handleSelectPinCamera = (value) => {
    setpinCamera(value);
    localStorage.setItem('pin_camera', value);
  };
  return (
    <div style={{ background: '#1F1E1E', height: '100%' }}>
      <Row>
        <Col span={12}>
          <div className="profile-component-data" style={{ marginRight: '8%' }}>
            <div className="profile-form" style={{ marginLeft: '8%' }}>
              <div
                style={{
                  fontSize: '14px',
                  fontWeight: 'unset',
                  margin: '5% 0px 2% 0px',
                  color: 'rgba(255, 255, 255, 0.65)',
                  textTransform: 'uppercase',
                }}
              >{`${t('Account')} - ${t('Identity Card')}`}</div>
              <Row
                style={{
                  border: '2px solid rgba(79, 77, 77, 0.5)',
                  boxShadow: '10px 10px 4px rgba(0, 0, 0, 0.25)',
                  borderRadius: '5px',
                }}
              >
                <Col span={6}>
                  <Form
                    form={form}
                    {...layout}
                    name="nest-messages"
                    onFinish={onFinish}
                    validateMessages={validateMessages}
                  >
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                          prevValues.avatar !== currentValues.avatar
                        }
                        noStyle
                      >
                        {({ getFieldValue }) => (
                          <img
                            style={{
                              width: '106px',
                              height: '106px',
                              marginTop: '45px',
                              marginBottom: '-10px',
                              borderRadius: '60px',
                              objectFit: 'cover',
                            }}
                            src={dataUser?.avatar}
                          />
                        )}
                      </Form.Item>
                    </div>
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Form.Item
                        style={{ marginBottom: 12 }}
                      >
                      </Form.Item>
                    </div>
                  </Form>
                </Col>
                <Col span={9}>
                  <Form form={form}>
                    <Form.Item
                      name="fullName"
                    >
                      <Input
                        disabled={!change1}
                        style={{
                          marginTop: '55px',
                          border: '1px solid #1f1e1e',
                          fontWeight: 'bold',
                          fontSize: '20px',
                          marginBottom: '10px',
                          background: 'rgb(31, 30, 30)',
                        }}
                      />
                    </Form.Item>
                    <div
                      style={{
                        fontSize: '13px',
                        color: '#FC573B',
                        marginLeft: '13px',
                        marginBottom: '5px',
                      }}
                    >
                      <img
                        style={{ width: '3px', height: '3px' }}
                        src={point}
                      />{' '}
                      {dataUser?.role === 'admin' ? t('Admin') : t('Member')}
                    </div>
                    <div
                      style={{
                        fontSize: '13px',
                        color: '#BDBBBB',
                        marginLeft: '13px',
                      }}
                    >
                      {t('Registration Date')}:{' '}
                      {dataUser &&
                        dataUser.createdAt &&
                        moment(dataUser.createdAt).format('DD/MM/YYYY')}
                    </div>
                    {!change1 ? (
                      <div
                        style={{
                          position: 'absolute',
                          top: 100,
                          right: 30,
                          cursor: 'pointer',
                          color: '#878787',
                        }}
                        onClick={() => onChange1('1')}
                      >
                        {t('Change')}?
                      </div>
                    ) : (
                      <div
                        style={{ position: 'absolute', top: 100, right: 10 }}
                      >
                        <span
                          style={{
                            marginRight: '10px',
                            cursor: 'pointer',
                            color: '#0E9347',
                          }}
                          onClick={() => onFinish1()}
                        >
                          {t('Accept')}
                        </span>
                        <span
                          style={{ cursor: 'pointer', color: '#4F4D4D' }}
                          onClick={() => onCancel1()}
                        >
                          {t('Cancel')}
                        </span>
                      </div>
                    )}
                  </Form>
                </Col>
                <Col span={9}>
                  <div
                    style={{
                      border: '2px solid #FF9D0A',
                      boxShadow: '10px 10px 4px rgba(0, 0, 0, 0.25)',
                      height: '130px',
                      borderRadius: '10px',
                      margin: '40px 22px',
                      background: '#FF9D0A',
                    }}
                  >
                    <div
                      style={{
                        textAlign: 'center',
                        marginTop: '13px',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        textTransform: 'uppercase',
                      }}
                    >
                      {t('Identity Card')}
                    </div>
                    <Form form={form}>
                      <Form.Item
                        name="idSocial"
                      >
                        <Input
                          disabled={!change2}
                          style={{
                            borderColor: '#FF9D0A',
                            fontWeight: 'bold',
                            fontSize: '20px',
                            color: '#000000',
                            textAlign: 'center',
                            background: 'rgb(255, 157, 10)',
                          }}
                        />
                      </Form.Item>
                    </Form>
                    {!change2 ? (
                      <div
                        style={{
                          cursor: 'pointer',
                          color: '#A52D13',
                          textAlign: 'center',
                          marginTop: '-5px',
                        }}
                        onClick={() => onChange1('2')}
                      >
                        {t('Change')}?
                      </div>
                    ) : (
                      <div
                        style={{
                          textAlign: 'center',
                          top: 70,
                          right: 10,
                          marginTop: '-5px',
                        }}
                      >
                        <span
                          style={{
                            marginRight: '10px',
                            cursor: 'pointer',
                            color: '#0E9347',
                          }}
                          onClick={() => onFinish1('idSocial')}
                        >
                          {t('Accept')}
                        </span>
                        <span
                          style={{ cursor: 'pointer', color: '#4F4D4D' }}
                          onClick={() => onCancel1()}
                        >
                          {t('Cancel')}
                        </span>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
            <div
              className="profile-form"
              style={{ marginLeft: '8%', position: 'relative' }}
            >
              <div
                style={{
                  fontSize: '14px',
                  fontWeight: 'unset',
                  margin: '5% 0px 2% 0px',
                  color: 'rgba(255, 255, 255, 0.65)',
                  textTransform: 'uppercase',
                }}
              >
                {t('Information')}
              </div>
              <Form
                form={form}
                {...layout}
                name="nest-messages"
                onFinish={onFinish}
                validateMessages={validateMessages}
              >
                <div
                  style={{
                    border: '2px solid rgba(79, 77, 77, 0.5)',
                    boxShadow: '10px 10px 4px rgba(0, 0, 0, 0.25)',
                    borderRadius: '5px',
                  }}
                >
                  <Form.Item
                    name="birthday"
                    label={t('Date of birth')}
                    style={{ margin: '0px' }}
                  >
                    <DatePicker
                      style={{
                        borderColor: '#1F1E1E',
                        background: 'rgb(31, 30, 30)',
                      }}
                      disabled={!change3}
                      format="DD-MM-YYYY"
                    />
                  </Form.Item>
                  <Divider style={{ margin: '0px' }} />
                  <Form.Item
                    name="email"
                    label={t('Email')}
                    style={{ margin: '0px' }}
                  >
                    <EmailTag
                      onChangeEmail={onChangeEmail}
                      disabled={!change4}
                    />
                  </Form.Item>
                  <Divider style={{ margin: '0px' }} />
                  <Form.Item
                    name="phoneNumber"
                    label={t('Phone number')}
                    style={{ margin: '0px' }}
                  >
                    <Input
                      style={{
                        borderColor: '#1F1E1E',
                        background: 'rgb(31, 30, 30)',
                        width: '75%',
                      }}
                      disabled
                    />
                  </Form.Item>
                  <Divider style={{ margin: '0px' }} />
                  <Form.Item
                    name="address"
                    label={t('Address')}
                    style={{ margin: '0px' }}
                  >
                    <Input
                      style={{
                        borderColor: '#1F1E1E',
                        background: 'rgb(31, 30, 30)',
                        width: '75%',
                      }}
                      disabled={!change5}
                    />
                  </Form.Item>
                </div>
                <div className="button-update">
                  <Button
                    onClick={() => handleOnLogout()}
                    style={{
                      marginTop: '5%',
                      color: 'rgba(255, 255, 255, 0.65)',
                    }}
                  >
                    {t('Logout')}
                  </Button>
                </div>
              </Form>
              {!change3 ? (
                <div
                  style={{
                    position: 'absolute',
                    top: 43,
                    right: 15,
                    cursor: 'pointer',
                    color: '#878787',
                  }}
                  onClick={() => onChange1('3')}
                >
                  {t('Change')}?
                </div>
              ) : (
                <div style={{ position: 'absolute', top: 43, right: 10 }}>
                  <span
                    style={{
                      marginRight: '10px',
                      cursor: 'pointer',
                      color: '#0E9347',
                    }}
                    onClick={() => onFinish1()}
                  >
                    {t('Accept')}
                  </span>
                  <span
                    style={{ cursor: 'pointer', color: '#4F4D4D' }}
                    onClick={() => onCancel1()}
                  >
                    {t('Cancel')}
                  </span>
                </div>
              )}
              {!change4 ? (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 140,
                    right: 15,
                    cursor: 'pointer',
                    color: '#878787',
                  }}
                  onClick={() => onChange1('4')}
                >
                  {t('Change')}?
                </div>
              ) : (
                <div style={{ position: 'absolute', bottom: 140, right: 10 }}>
                  <span
                    style={{
                      marginRight: '10px',
                      cursor: 'pointer',
                      color: '#0E9347',
                    }}
                    onClick={() => onFinish1()}
                  >
                    {t('Accept')}
                  </span>
                  <span
                    style={{ cursor: 'pointer', color: '#4F4D4D' }}
                    onClick={() => onCancel1()}
                  >
                    {t('Cancel')}
                  </span>
                </div>
              )}
              {!change5 ? (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 73,
                    right: 15,
                    cursor: 'pointer',
                    color: '#878787',
                  }}
                  onClick={() => onChange1('5')}
                >
                  {t('Change')}?
                </div>
              ) : (
                <div style={{ position: 'absolute', bottom: 73, right: 10 }}>
                  <span
                    style={{
                      marginRight: '10px',
                      cursor: 'pointer',
                      color: '#0E9347',
                    }}
                    onClick={() => onFinish1()}
                  >
                    {t('Accept')}
                  </span>
                  <span
                    style={{ cursor: 'pointer', color: '#4F4D4D' }}
                    onClick={() => onCancel1()}
                  >
                    {t('Cancel')}
                  </span>
                </div>
              )}
            </div>
          </div>
        </Col>
        <Col span={12} style={{ marginTop: '2%' }}>
          <Tabs type="card" className="tab-config">
            <TabPane tab={t('ACCESS TOKEN')} key="1">
              <div className="child token-component">
                {/* <h3>{t('Share Access Token')}</h3> */}
                <div className="share-token">
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: 'unset',
                      marginBottom: '2%',
                      textTransform: 'uppercase',
                    }}
                  >
                    {t('Share Access Token')}
                  </div>
                  <Row>
                    <Col span={13}>
                      <Spin spinning={!token}>
                        <Paragraph copyable={{ text: token && token }}>
                          <Input
                            style={{ width: '80%', marginRight: '5%' }}
                            value={token}
                          />
                        </Paragraph>
                      </Spin>
                    </Col>
                    <Button
                      onClick={() => handleResetToken()}
                      icon={
                        <ReloadOutlined spin={resetting} disabled={resetting} />
                      }
                      type="primary"
                    >
                      Reset
                    </Button>
                    {/* </Col> */}
                  </Row>
                  <Row>
                    <Button
                      onClick={() => setOpenModalChangePassword(true)}
                      type="primary"
                    >
                      {t('Change password')}
                    </Button>
                  </Row>
                </div>
              </div>
            </TabPane>
            <TabPane tab={t('LICENSE')} key="2">
              <div className="child language" style={{ marginBottom: '5%' }}>
                <div className="select-language" style={{ width: '100%' }}>
                  <div style={{ display: 'flex' }}>
                  </div>
                  {change6 && (
                    <Table
                      pagination={false}
                      scroll={{ y: 155 }}
                      style={{ border: '1px solid #303030' }}
                      size="small"
                      columns={[
                        {
                          title: t('License code'),
                          dataIndex: 'licenseCode',
                          key: 'licenseCode',
                          width: '25%',
                          align: 'center',
                        },
                        {
                          title: t('Service'),
                          dataIndex: 'serviceName',
                          key: 'serviceName',
                          width: '40%',
                          align: 'center',
                        },
                        {
                          title: t('Create date'),
                          dataIndex: 'startAt',
                          key: 'startAt',
                          width: '20%',
                          align: 'center',
                          render: (time) => moment(time).format('DD/MM/YYYY'),
                        },
                        {
                          title: t('Action'),
                          key: 'actions ',
                          width: '15%',
                          align: 'center',
                          render: (record) => (
                            <div className="manager-member-actions">
                              {record?.configuration &&
                                Object.keys(record.configuration)?.length >
                                  0 && (
                                  <Tooltip
                                    placement="left"
                                    mouseEnterDelay={0.5}
                                    title={
                                      <Row>
                                        <div style={{ marginTop: '8px' }}>
                                          <img
                                            alt="live-stream-icon"
                                            style={{
                                              marginTop: '-2px',
                                              marginRight: '5px',
                                              width: '16px',
                                              height: '16px',
                                            }}
                                            src={All_Services}
                                          />
                                          <span>{t('Configuration')}</span>
                                        </div>
                                        {Object.keys(record.configuration).map(
                                          (key, index) => {
                                            return (
                                              <Col
                                                span={24}
                                                style={{
                                                  marginTop: '10px',
                                                  fontSize: '13px',
                                                  display: 'flex',
                                                  justifyContent:
                                                    'space-between',
                                                  textTransform: 'capitalize',
                                                }}
                                                key={index}
                                              >
                                                {key}:{' '}
                                                <span>
                                                  {record.configuration?.[key]}
                                                </span>
                                              </Col>
                                            );
                                          }
                                        )}
                                      </Row>
                                    }
                                  >
                                    <InfoCircleOutlined
                                      style={{
                                        alignSelf: 'center',
                                        fontSize: '18px',
                                        cursor: 'pointer',
                                      }}
                                    />
                                  </Tooltip>
                                )}
                            </div>
                          ),
                        },
                      ]}
                      dataSource={listLicense}
                    />
                  )}
                </div>
              </div>
            </TabPane>
            <TabPane tab={t('CONFIGURATION')} key="3">
              <div className="child namespace" style={{ marginBottom: '3%' }}>
                {/* <h3>{t('Namespace settings')}</h3> */}
                <div className="select-language">
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: 'unset',
                      marginBottom: '2%',
                      textTransform: 'uppercase',
                    }}
                  >
                    {t('Namespace')}
                  </div>
                  <Select
                    value={namespace}
                    onChange={handleChangeNamespace}
                    loading={!namespaces}
                  >
                    {namespaces &&
                      namespaces.map((namespace) => (
                        <Option key={namespace} value={namespace}>
                          {namespace}
                        </Option>
                      ))}
                  </Select>
                </div>
              </div>
              <div className="child language" style={{ marginBottom: '5%' }}>
                {/* <h3>{t('System settings')}</h3> */}
                <div className="select-language">
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: 'unset',
                      marginBottom: '2%',
                      textTransform: 'uppercase',
                    }}
                  >
                    {t('Language setting')}
                  </div>
                  <Radio.Group
                    value={language}
                    onChange={(event) =>
                      handleUpdateLanguage(event.target.value)
                    }
                    style={{ width: '100%' }}
                  >
                    <Radio value="vi" style={{ marginRight: '5%' }}>
                      {t('Vietnamese')}
                    </Radio>
                    <Radio value="en">{t('English')}</Radio>
                  </Radio.Group>
                </div>
              </div>
              <div className="child namespace" style={{ marginBottom: '3%' }}>
                <div className="select-language">
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: 'unset',
                      marginBottom: '2%',
                      textTransform: 'uppercase',
                    }}
                  >
                    {t('Camera')}
                  </div>
                  <div style={{ marginBottom: '2%' }}>
                    <Select
                      value={modeCamera}
                      onChange={handleSelectMode}
                      style={{ width: '150px' }}
                    >
                      <Option key={'auto'} value={'auto'}>
                        {'Auto'}
                      </Option>
                      <Option key={'fast'} value={'fast'}>
                        {'Fast (TCP/HTTP)'}
                      </Option>
                      <Option key={'ultra_fast'} value={'ultra_fast'}>
                        {'Ultra Fast (UDP)'}
                      </Option>
                    </Select>
                  </div>
                  <div>
                    <span style={{ marginRight: '8px' }}>
                      {t('Pin the camera name')}
                    </span>
                    <Switch
                      checked={pinCamera}
                      onChange={handleSelectPinCamera}
                    />
                  </div>
                </div>
              </div>
            </TabPane>
          </Tabs>
        </Col>
      </Row>

      {openModalChangePassword && (
        <ChangePassword
          openModalChangePassword={openModalChangePassword}
          setOpenModalChangePassword={setOpenModalChangePassword}
        />
      )}
    </div>
  );
};

export default ProfilePage;
